<template>
	<el-upload class="avatar-uploader" :action="image_up+'uploadImg'" :data="{name:name}" :show-file-list="false" :before-upload="before_upload" :on-success="function(res, file){imageSuccess(res, file)} ">
		<img v-if="value" :src="value" class="avatar">
		<i v-else class="el-icon-plus avatar-uploader-icon"></i>

	</el-upload>
</template>
<script>
export default {
	name: 'upload',
	model: {
		prop: 'value',
		event: 'change'
	},
	props:{
		value: {
			type: String,
			default: ''
		},
		name: {
			type: [String,Number],
			default: 'company'
		},
	},
	data() {
		return {
			image_up: process.env.API_UP,
		}
	},
	watch: {
	},
	// 初始事件
	mounted: function () {
		
	},
	// 事件
	methods: {
		before_upload(file){
	        const isLt1M = file.size / 1024 / 1024 < 1;
			if(!isLt1M){
				var message='为节约服务器流量费用，上传图片请控制在1MB内，压缩图片工具网站：<a href="https://tinypng.com/" target="_blank">https://tinypng.com/</a>';
				if(this.lang!='cn'){
					message='Save server traffic costs, please control pictures within 1MB. Compress picture tool website:<a href="https://tinypng.com/" target="_blank">https://tinypng.com/</a>';
				}
				this.$message({
					type:'warning',
			        dangerouslyUseHTMLString: true,
					message:message,
				});
				return isLt1M;
			}else{
				this.loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			}
		},
		imageSuccess(res,file){
			this.$emit('callback', res,file);
			this.loading.close();
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/upload.vue